import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import { NODE_ENV } from '@/config';

import appModule, { name as appModuleName } from '@/store/modules/app';
import commonModule, {
  name as commonModuleName,
} from '@/store//modules/common';
import userModule, { name as userModuleName } from '@/store/modules/user';

Vue.use(Vuex);

const debug = NODE_ENV !== 'production';

//Only Modules is always loaded with the app
export const modulesName = {
  appModuleName: appModuleName,
  commonModuleName: commonModuleName,
  userModuleName: userModuleName,
};

export default new Vuex.Store({
  strict: debug,
  modules: {
    [appModuleName]: appModule,
    [commonModuleName]: commonModule,
    [userModuleName]: userModule,
  },
  plugins: debug ? [createLogger()] : [],
});
